import DEFAULT_OPERATIONS from "@/hooks/SearchPage/searchPage.gql"
import mergeOperations from "@/util/shallowMerge"
import {
  useQuery
} from "@apollo/client"
import {
  useSearchParams
} from "next/navigation"

export const useGetSortMethods = () => {
  const operations = mergeOperations(DEFAULT_OPERATIONS)
  const searchParams = useSearchParams()
  const {
    getSearchAvailableSortMethods,
  } = operations
  const inputText = searchParams.get("query")


  const {
    data: sortData 
  } = useQuery(
    getSearchAvailableSortMethods,
    {
      fetchPolicy: "cache-first",
      nextFetchPolicy: "cache-first",
      skip: !inputText,
      variables: {
        search: inputText,
      }
    }
  )

  const availableSortMethods = sortData
    ? sortData.products.sort_fields.options
    : null

  return {
    sortData,
    availableSortMethods
  }
}
